export default "__VITE_ASSET__BL_d40Pe__"